import posthog from 'posthog-js'
import { defaultConfig } from '@/config'

const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST || '/ingest'

let posthogInitialized = false

export function initPostHog(): void {
  if (posthogInitialized) return
  const cfg = defaultConfig()
  if (cfg.envMode !== 'production') return

  const key = import.meta.env.VITE_POSTHOG_KEY
  if (!key) return

  posthog.init(key, {
    api_host: POSTHOG_HOST,
    ui_host: 'https://eu.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: false,
    capture_pageleave: true,
  })
  posthogInitialized = true
}

export function isPostHogEnabled(): boolean {
  const cfg = defaultConfig()
  return (
    cfg.envMode === 'production' && Boolean(import.meta.env.VITE_POSTHOG_KEY)
  )
}

export { posthog }
